import { render, staticRenderFns } from "./Portals.vue?vue&type=template&id=5d48a5e3&scoped=true&"
import script from "./Portals.vue?vue&type=script&lang=js&"
export * from "./Portals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d48a5e3",
  null
  
)

export default component.exports